export function makeMinCharactersValidator<T>(minCharacters: number, errorMsg: T) {
  return (value?: string) => {
    if (value && value?.trim().length < minCharacters) {
      return errorMsg;
    }
    return undefined;
  };
}
